import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { POLICY_STATUS } from '../../../constants';

import clockCircleTimeIcon from '../../../assets/policy/clock-circle-time.svg';
import arrowRightDisabledIcon from '../../../assets/chevron-disabled.svg';
import arrowRightIcon from '../../../assets/chevron-white-right.svg';
import checkOnyxIcon from '../../../assets/check-onyx.svg';

import './Policy.css';

const PolicyDetailsField = ({
  label = '',
  value = '',
  rowInMobile = false,
}) => (
  <div
    className={`Policy-action-card-column${
      rowInMobile ? '-mobile-row' : ''}`}
  >
    <p className="Policy-action-card-label">
      {label}
    </p>

    <p className="Policy-action-card-value">
      {value}
    </p>
  </div>
);

const PolicyDetailsHeader = ({ title, description }) => (
  <div className="Policy-details-header-field">
    <p>{title}</p>

    <span>{description}</span>
  </div>
);

const Policy = ({ goToNextStep = () => { } }) => {
  const { t } = useTranslation('common');

  // TODO: get real policy data
  const policyData = {
    company: 'Company Inc.',
    continueButtonDisabled: true,
    planActionsCardContent: [{
      coveragePeriod: '5/19/2022 - 5/18/2023',
      petsInPeriod: '1 Dog, 3 Cats',
      petsInPeriodNames: '--',
      planName: 'Accident & Illness',
      removedPets: '2 Cats',
      removedPetsNames: '--',
      status: 0,
    }],
    policyCertificateNumber: '#940039849521',
    policyPeriods: '3 Coverage Periods',
  };

  return (
    <div className="Policy-content">
      <div className="Policy-title-container">
        <h2 className="Policy-title">{t('policy.title')}</h2>

        <span className="Policy-title-status-chip">
          &#9679; {t('policy.policyStatus.1')}
        </span>
      </div>

      <div className="Policy-details-container">
        <PolicyDetailsHeader
          description={policyData.policyCertificateNumber}
          title={t('policy.details.certificateNumber')}
        />

        <PolicyDetailsHeader
          description={policyData.policyPeriods}
          title={t('policy.details.policyPeriods')}
        />

        <PolicyDetailsHeader
          description={policyData.company}
          title={t('policy.details.company')}
        />
      </div>

      <div className="Policy-actions">
        <h4 className="Policy-actions-title">
          <Trans
            components={{
              coverages: <span className="Policy-actions-title-blue" />,
            }}
            i18nKey="policy.policyActionsCardHeading"
            ns="common"
            values={{
              coverages: policyData?.planActionsCardContent.length || 0,
            }}
          />
        </h4>

        <div className="Policy-action-cards">
          {policyData.planActionsCardContent.map((card) => (
            <div
              key={`coverageCard-${card.coveragePeriod}`}
              className="Policy-action-card"
            >
              <div className="Policy-action-card-details">
                <div className="Policy-action-card-section">
                  <h1>{t('policy.policyActionCardContent.policyDetails')}</h1>

                  <div className="Policy-action-card-section-row">
                    <PolicyDetailsField
                      label={t('policy.policyActionCardContent.coveragePeriod')}
                      value={card.coveragePeriod}
                    />

                    <PolicyDetailsField
                      label={t('policy.policyActionCardContent.planName')}
                      value={card.planName}
                    />
                  </div>
                </div>

                <div className="Policy-action-card-section-divider" />

                <div className="Policy-action-card-section">
                  <h1>{t('policy.policyActionCardContent.petsInPeriod')}</h1>

                  <div className="Policy-action-card-section-row">
                    <PolicyDetailsField
                      label="Covered"
                      rowInMobile
                      value={card.petsInPeriod}
                    />

                    <PolicyDetailsField
                      label={t('policy.policyActionCardContent.removed')}
                      rowInMobile
                      value={card.removedPets}
                    />
                  </div>
                </div>

                <div className="Policy-action-card-button-container">
                  <button
                    className="Policy-action-card-button"
                    type="button"
                  >

                    {t('policy.policyActionCardContent.completeInformation')}

                    <div className="Policy-action-card-button-underline" />
                  </button>
                </div>
              </div>

              <div
                className={`Policy-action-status-chip ${
                    card.status === POLICY_STATUS.cancelled
                      ? 'Policy-action-status-chip-pending'
                      : 'Policy-action-status-chip-active'
                  }`}
              >

                <img
                  alt={t('imgAlts.coverageStatusIcon')}
                  className="Policy-title-status-icon"
                  src={card.status === POLICY_STATUS.cancelled
                    ? clockCircleTimeIcon
                    : checkOnyxIcon}
                />

                <span>{t(`policy.coverageStatus.${card.status}`)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="Policy-continue-button-container">
        <button
          className="Policy-continue-button"
          disabled={policyData.continueButtonDisabled}
          onClick={goToNextStep}
          type="button"
        >
          {t('policy.policyActionCardContent.continueToPetcloud')}

          <img
            alt={t('imgAlts.chevronRight')}
            src={policyData.continueButtonDisabled
              ? arrowRightDisabledIcon : arrowRightIcon}
          />
        </button>
      </div>
    </div>
  );
};

export { Policy };
